import { Navigate, Outlet } from 'react-router'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { routes } from '@/routes'

function MarqueeRoute() {
	const accessToken = useAuthStore((state) => state.accessToken)

	if (!accessToken) {
		return <Navigate replace to={routes.MARQUEE_LOGIN.handle.fullPath} />
	}

	return <Outlet />
}

export { MarqueeRoute }
